import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { setCredentials } from "../features/auth/authSlice";
import config from "../config"

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [contact, setContact] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await axios.post(`${config.API_BASE_URL}/customer/logincustomer`, {
        contact,
        password,
      });

     // const token = response?.data?.data?.token;
     const { status, data } = response.data;   //new
    
    if (status && data) {    //new
      const { token, isSecondaryUser, secondaryUserInfo } = data;  //new

      if (token) {
        // ✅ Update Redux store with credentials - this will trigger cart sync
        dispatch(setCredentials({ token, 
          phone: contact,
          isSecondaryUser: isSecondaryUser || false, //new
          secondaryUserInfo: secondaryUserInfo || null //new
         }));
        
        toast.success("Login successful");
        //navigate("/profile");
        // Navigate based on user type
        if (isSecondaryUser) {  //new
          navigate("/records/profile");   //new
        } else {  //new
          navigate("/profile"); //new
        }
      } else {
        toast.error("Login failed. Please try again.");
        setError("Login failed. Please try again.");
      }
    }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Invalid contact or password.");
      setError("Invalid contact or password.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-orange-100 via-yellow-50 to-amber-100 relative overflow-hidden">
      <div className="relative z-10 transform hover:scale-105 transition-transform duration-300">
        <div className="bg-white p-8 rounded-3xl shadow-2xl w-full max-w-md space-y-6 border border-orange-100 backdrop-blur-sm animate-fade-in">
          {/* Logo and Title Section */}
          <div className="text-center space-y-4">
            <div className="relative inline-block">
              <div className="w-20 h-20 mx-auto rounded-full shadow-lg border-4 border-orange-200 hover:border-orange-300 transition-colors duration-300 bg-gradient-to-br from-orange-300 to-amber-300 flex items-center justify-center animate-float">
                <span className="text-3xl">🐕</span>
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-orange-700 mb-1 animate-slide-down">
                Welcome Back!
              </h2>
              {/* <p className="text-orange-600 text-sm font-medium animate-slide-down" style={{animationDelay: '0.2s'}}>
                Pet Grooming & Boarding Services
              </p> */}
            </div>
          </div>

          {/* Contact Input */}
          <div className="space-y-2 animate-slide-up" style={{animationDelay: '0.4s'}}>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Contact Number
            </label>
            <div className="relative">
              <input
                type="text"
                placeholder="Enter your contact number"
                value={contact}
                onChange={(e) => setContact(e.target.value)}
                className="w-full px-4 py-3 border-2 border-orange-200 rounded-xl shadow-sm focus:ring-2 focus:ring-orange-400 focus:border-orange-400 focus:outline-none transition-all duration-300 hover:border-orange-300"
                required
              />
            </div>
          </div>

          {/* Password Input */}
          <div className="relative space-y-2 animate-slide-up" style={{animationDelay: '0.6s'}}>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border-2 border-orange-200 rounded-xl shadow-sm focus:ring-2 focus:ring-orange-400 focus:border-orange-400 focus:outline-none transition-all duration-300 hover:border-orange-300 pr-12"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-1/2 right-4 transform -translate-y-1/2 text-gray-500 hover:text-orange-600 focus:outline-none transition-colors duration-200"
              >
                {showPassword ? <FaEyeSlash className="w-5 h-5" /> : <FaEye className="w-5 h-5" />}
              </button>
            </div>
          </div>

          {error && (
            <div className="text-red-500 text-sm bg-red-50 p-3 rounded-lg border border-red-200 animate-shake">
              {error}
            </div>
          )}

          {/* Login Button */}
          <button
            type="button"
            onClick={handleLogin}
            disabled={isLoading}
            className={`w-full py-3 rounded-xl font-semibold text-white transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg animate-slide-up ${
              isLoading 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 hover:shadow-xl'
            }`}
            style={{animationDelay: '0.8s'}}
          >
            {isLoading ? (
              <div className="flex items-center justify-center space-x-2">
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>Logging in...</span>
              </div>
            ) : (
              <span>Login</span>
            )}
          </button>

          {/* Footer Text */}
          <div className="text-center animate-fade-in" style={{animationDelay: '1s'}}>
            <p className="text-xs text-gray-500">
              Trusted pet care services since 2020
            </p>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-down {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }

        .animate-slide-up {
          animation: slide-up 0.6s ease-out forwards;
          opacity: 0;
        }

        .animate-slide-down {
          animation: slide-down 0.6s ease-out forwards;
          opacity: 0;
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }

        .animate-shake {
          animation: shake 0.5s ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default Login;